import { useEffect, useState } from 'react';
import useAuthStore from '../store/authStore';

export const storageName = 'MOOD_is_authenticated';

/**
 * Custom hook to watch changes in authentication state and persist it to IndexedDB
 */
export const useWatchAuthenticationState = () => {
  const [storedIsAuthenticated, setStoredIsAuthenticated] = useState<
    boolean | null
  >(null);

  useEffect(() => {
    try {
      const rawValue = localStorage.getItem(storageName);

      const storedValue =
        rawValue === 'true' ? true : rawValue === 'false' ? false : false;

      setStoredIsAuthenticated(storedValue);
    } catch (error) {
      console.error('Error reading auth state from localStorage:', error);
      setStoredIsAuthenticated(false);
    }
  }, []);

  useEffect(() => {
    const unsubscribe = useAuthStore.subscribe(({ isAuthenticated }) => {
      localStorage.setItem(storageName, String(isAuthenticated()));
      setStoredIsAuthenticated(isAuthenticated());
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return storedIsAuthenticated;
};
